import { render, staticRenderFns } from "./RightsNo.vue?vue&type=template&id=a25ce7c4"
import script from "./RightsNo.vue?vue&type=script&lang=js"
export * from "./RightsNo.vue?vue&type=script&lang=js"
import style0 from "./RightsNo.vue?vue&type=style&index=0&id=a25ce7c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports